import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FaKey, FaTimes, FaUser } from 'react-icons/fa';
import { resetAdminUserPasswordAct } from '../../../../../Redux/Dashboard/External/AdminUsers/Actions/ResetAdminUserPasswordAction';
import { mapResetAdminUserPasswordError } from '../accountCreationHelpers';

const ResetPasswordModal = ({ isOpen, user, onClose, onSuccess }) => {
  const dispatch = useDispatch();
  const isResetting = useSelector((state) => state.AdminResetUserPassword?.loading);
  const [submitError, setSubmitError] = useState('');

  useEffect(() => {
    if (isOpen) {
      setSubmitError('');
    }
  }, [isOpen, user?.email]);

  const handleClose = () => {
    if (isResetting) {
      return;
    }

    setSubmitError('');
    onClose();
  };

  const handleConfirmReset = async () => {
    if (isResetting || !user?.email) {
      return;
    }

    setSubmitError('');

    try {
      const response = await dispatch(resetAdminUserPasswordAct(user.email));

      if (!response?.password) {
        setSubmitError(mapResetAdminUserPasswordError(
          'Unable to reset the password. Please try again.'
        ));
        return;
      }

      onSuccess({
        fullName: user.name,
        email: user.email,
        username: user.email,
        password: response.password,
      });
    } catch (error) {
      setSubmitError(mapResetAdminUserPasswordError(error?.message));
    }
  };

  if (!isOpen || !user) {
    return null;
  }

  return (
    <div
      className="admin-users-modal-overlay admin-users-create-overlay"
      onClick={isResetting ? undefined : handleClose}
    >
      <div
        className="admin-users-modal admin-users-modal--reset-password"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="reset-password-modal-title"
      >
        <div className="admin-users-reset-modal__header">
          <div className="admin-users-reset-modal__header-main">
            <div className="admin-users-reset-modal__header-icon" aria-hidden="true">
              <FaKey />
            </div>
            <div>
              <h2 className="admin-users-reset-modal__title" id="reset-password-modal-title">
                Reset User Password
              </h2>
              <p className="admin-users-reset-modal__subtitle">
                Reset the Tech Central password for this user.
              </p>
            </div>
          </div>
          <button
            type="button"
            className="admin-users-reset-modal__close"
            onClick={handleClose}
            disabled={isResetting}
            aria-label="Close reset password modal"
          >
            <FaTimes />
          </button>
        </div>

        <div className="admin-users-reset-modal__body">
          {submitError && (
            <div className="admin-users-create-form__submit-error" role="alert">
              {submitError}
            </div>
          )}

          <div className="admin-users-reset-modal__user-card">
            <div className="admin-users-reset-modal__user-icon" aria-hidden="true">
              <FaUser />
            </div>
            <div>
              <div className="admin-users-reset-modal__user-name">{user.name}</div>
              <div className="admin-users-reset-modal__user-email">{user.email}</div>
            </div>
          </div>

          <div className="admin-users-reset-modal__warning">
            The user&apos;s current password will stop working immediately after the reset.
          </div>
        </div>

        <div className="admin-users-reset-modal__footer">
          <button
            type="button"
            className="admin-users-create-form__button admin-users-create-form__button--cancel"
            onClick={handleClose}
            disabled={isResetting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="admin-users-create-form__button admin-users-create-form__button--primary"
            onClick={handleConfirmReset}
            disabled={isResetting}
          >
            {isResetting ? 'Resetting...' : 'Reset Password'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordModal;
